import React, { useContext } from 'react'
import { fareCabinLabelMap, FlightsClassTypes } from 'constants/flight'
import OfferFilterDropdownBox from '../OfferFilterDropdownBox'
import LineSeatIcon from 'LuxKit/Icons/line/LineSeatIcon'
import ModalContext from 'contexts/ModalContext'
import MaldivesCharterFlightFareClassModal from './MaldivesCharterFlightFareClassModal'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'

interface Props {
  fareClass: FlightsClassTypes
  className?: string
}

function CharterFlightFareClassSelect({ fareClass, className }: Props) {
  const openModal = useContext(ModalContext)
  const dispatch = useOfferPageDispatch()

  const openFareClassModal = async() => {
    const selectedClass = await openModal<FlightsClassTypes>(<MaldivesCharterFlightFareClassModal selectedClassId={fareClass} />)
    if (selectedClass) {
      dispatch({ type: OfferPageActions.setFareClass, fareClass: selectedClass })
    }
  }

  return (
    <OfferFilterDropdownBox
      className={className}
      data-testid="fare-class-select"
      onClick={openFareClassModal}
      icon={<LineSeatIcon />}
      label="Class"
      value={fareCabinLabelMap[fareClass]}
      placeholder="Select fare class"
    />
  )
}

type MappedProps = Pick<Props, 'fareClass'>

export default withOfferPageState((state): MappedProps => ({
  fareClass: state.fareClass,
}), CharterFlightFareClassSelect)
